import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import ReactStars from "react-rating-stars-component";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { toast } from "react-toastify";

const MeetingRating = ({
  juniorListForImmediateSenior,
  getJuniorListForImmediateSenior = [],
  fetchRatingEmailDropdown,
  emailDropdownFilter = [],
  match,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const Headers = [
    "Name",
    "Email",
    "Meeting Date",
    "Meeting Duration(Minutes)",
    "Subject",
    "Body",
    "Status",
    "View Meeting",
  ];

  useEffect(() => {
    if (juniorListForImmediateSenior !== null)
      (async () => {
        setIsLoading(true);
        await juniorListForImmediateSenior(null, 1);
        await fetchRatingEmailDropdown("junior");
        setIsLoading(false);
      })();
  }, [juniorListForImmediateSenior]);

  useEffect(() => {
    const tableData = [
      "id",
      "name",
      "email",
      "scheduled_date",
      "duration_in_minutes",
      "subject",
      "body",
      "already_rated",
      "View Meeting",
    ];
    if (
      getJuniorListForImmediateSenior &&
      getJuniorListForImmediateSenior.data &&
      getJuniorListForImmediateSenior.data.data &&
      getJuniorListForImmediateSenior.data.data.length > 0
    ) {
      const data = getJuniorListForImmediateSenior.data.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            // Action: [
            //   {
            //     name: "View Details",
            //     link: `${baseUrl}/brand-activation/meeting-details`,
            //   },
            // ],
          }
        )
      );
      if (data) {
        setListData(data);
      } else {
        setListData([]);
      }

      setPageCount(
        Math.ceil(
          getJuniorListForImmediateSenior.data.total /
            getJuniorListForImmediateSenior.data.per_page
        )
      );
    }
  }, [getJuniorListForImmediateSenior]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await juniorListForImmediateSenior(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handleMeetingView = (id) => {
    const url = `${baseUrl}/brand-activation/meeting-details/${id}`;
    window.location.href = url;
  }
  

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await juniorListForImmediateSenior(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };



  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.meetingRating}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={Headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={getJuniorListForImmediateSenior?.data?.from}
        handleMeetingView={handleMeetingView}
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        meetingRatingsFilter
        emailDropdownFilter={emailDropdownFilter}
        type={"SENIOR"}
        userFilter={true}
      />
    </Layout>
  );
};

MeetingRating.propTypes = {
  usersListingUnderHod: PropTypes.any,
  getUserListsHod: PropTypes.func,
  match: PropTypes.any,
};

export default MeetingRating;
